module.exports = __webpack_public_path__ + "img/camper-winter-checklist.fb9f3a7.svg";